import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "contents1"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  id: "contents1"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "com_inner1 clearfix" }
const _hoisted_7 = {
  key: 0,
  class: "error-message com_mgb10",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_8 = { class: "com_inner1 clearfix" }
const _hoisted_9 = {
  class: "com_i_title1 com_mgt20",
  style: {"min-height":"48px"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "実績データ", -1)
const _hoisted_12 = { class: "com_topic_list4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "head1" }, [
  /*#__PURE__*/_createElementVNode("div", null, "更新日付"),
  /*#__PURE__*/_createElementVNode("div", null, "名称／内容"),
  /*#__PURE__*/_createElementVNode("div", null, "ダウンロード")
], -1)
const _hoisted_14 = { class: "meta1" }
const _hoisted_15 = { class: "date1 roboto" }
const _hoisted_16 = { class: "body1" }
const _hoisted_17 = { class: "t1" }
const _hoisted_18 = { class: "t2" }
const _hoisted_19 = { class: "buttons1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BreadcrumbsComponent = _resolveComponent("BreadcrumbsComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BreadcrumbsComponent, {
                title: '',
                categoryId: _ctx.categoryId
              }, null, 8, ["categoryId"])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("img", {
                    src: _ctx.getImageUrl('icon-c-data1.png'),
                    alt: "",
                    class: "icon-c-data1"
                  }, null, 8, _hoisted_10),
                  _hoisted_11
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDisplayList(
              _ctx.ReportDownloadConstants.RPT_KBN_ACHIEVEMENT_DATA
            ), (rpt, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(rpt.updDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            to: rpt.categoryUrl,
                            class: "com_link1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(rpt.rptName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(rpt.rptGaiyo), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        to: rpt.categoryUrl,
                        class: "com_dl_button2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}